
// Called when vue dialogs are shown/hidden for compatibility with admin modal overlays
export function handleDialogVisibility(isVisible) {
	try {
		if (!window)
			console.warn('Window not defined');
	}
	catch {
		return;
	}

	// do not hide the overlay if a legacy modal is open underneath a vue dialog
	if (window.Cognito && window.Cognito.Messaging && (isVisible || !document.body.className.includes('c-modal-active'))) {
		// eslint-disable-next-line no-undef
		Cognito.Messaging.trigger(isVisible ? 'showOverlay' : 'hideOverlay');
	}
}

export function setupChromeOverlayClickHandler(handler) {
	try {
		if (!window)
			console.warn('Window not defined');
	}
	catch {
		return;
	}

	if (window.Cognito && window.Cognito.Messaging) {
		// eslint-disable-next-line no-undef
		Cognito.Messaging.addHandler('overlayClicked', handler);
	}
}

export function removeChromeOverlayClickHandler(handler) {
	try {
		if (!window)
			console.warn('Window not defined');
	}
	catch {
		return;
	}

	if (window.Cognito && window.Cognito.Messaging) {
		// eslint-disable-next-line no-undef
		Cognito.Messaging.removeHandler('overlayClicked', handler);
	}
}